<template>
  <HermesCard :title="`Compare #${a} and #${b}`" meta="B against A, paired by case">
    <div class="flex flex-wrap items-center gap-6 mb-4">
      <label class="inline-flex items-center gap-2">
        <span class="text-gray-500">A: #{{ a }}</span>
        <select v-model="av" :class="SIZED_INPUT" @change="compare"><option value="">all variants</option><option v-for="v in variantsA" :key="v" :value="v">{{ v }}</option></select>
      </label>
      <label class="inline-flex items-center gap-2">
        <span class="text-gray-500">B: #{{ b }}</span>
        <select v-model="bv" :class="SIZED_INPUT" @change="compare"><option value="">all variants</option><option v-for="v in variantsB" :key="v" :value="v">{{ v }}</option></select>
      </label>
    </div>
    <p v-if="error" class="text-red-600">{{ error }}</p>
    <p v-else-if="loading" class="text-gray-500">Comparing…</p>
    <CompareTable v-else-if="result" :comparison="result" :a-name="nameA" :b-name="nameB" />
  </HermesCard>
</template>

<script>
import HermesCard from '../HermesCard.vue';
import { API, SIZED_INPUT, errorOf } from '../hermes';
import CompareTable from './CompareTable.vue';

export default {
  name: 'TestCompare',
  components: { HermesCard, CompareTable },
  props: { bench: { type: Object, required: true }, a: { type: Number, required: true }, b: { type: Number, required: true } },
  data() {
    return { av: '', bv: '', variantsA: [], variantsB: [], result: null, loading: false, error: '', SIZED_INPUT };
  },
  computed: {
    nameA() {
      return `#${this.a}${this.av ? ` ${this.av}` : ''}`;
    },
    nameB() {
      return `#${this.b}${this.bv ? ` ${this.bv}` : ''}`;
    },
  },
  watch: {
    a() { this.init(); },
    b() { this.init(); },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.av = '';
      this.bv = '';
      try {
        const [ra, rb] = await Promise.all([
          this.$axios.get(`${API}/console/bench/runs/${this.a}/`),
          this.$axios.get(`${API}/console/bench/runs/${this.b}/`),
        ]);
        this.variantsA = ra.data.variants || [];
        this.variantsB = rb.data.variants || [];
        if (this.variantsA.length > 1) [this.av] = this.variantsA;
        if (this.variantsB.length > 1) this.bv = this.variantsB[this.a === this.b ? 1 : 0];
      } catch (e) {
        this.error = errorOf(e, 'The runs could not be loaded.');
        return;
      }
      this.compare();
    },
    async compare() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await this.$axios.get(`${API}/console/bench/compare/`, { params: { a: this.a, b: this.b, av: this.av || undefined, bv: this.bv || undefined } });
        this.result = data;
      } catch (e) {
        this.error = errorOf(e, 'The runs could not be compared.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
